import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck, Lock, Download } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-navy text-white py-20 md:py-32 overflow-hidden" data-id="element-82">
      {/* Subtle US Map Texture Background */}
      <div className="absolute inset-0 opacity-10 bg-center bg-no-repeat bg-cover mix-blend-overlay" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1501594907352-04cda38ebc29?auto=format&fit=crop&q=80&w=2000")'
    }} data-id="element-83" />

      <div className="relative max-w-5xl mx-auto px-4 text-center z-10" data-id="element-84">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-85">
          <p className="text-gold text-sm md:text-base font-bold tracking-wider uppercase mb-6" data-id="element-86">
            Para el Emprendedor Cristiano Latino en EE.UU. que está listo para
            dar el paso de fe...
          </p>

          <h1 className="text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-8 text-balance" data-id="element-87">
            ¿Y Si Tu Negocio Fuera Tu Mayor Acto de Adoración a Dios?
          </h1>

          <h2 className="text-lg md:text-xl text-white/90 font-opensans max-w-3xl mx-auto mb-12 leading-relaxed text-balance" data-id="element-88">
            Descubre el Blueprint de +40 Páginas que le enseña al Propietario
            Cristiano Hispano cómo construir una empresa rentable de 6 cifras en
            EE.UU. sin negociar su fe, sin perder a su familia y sin miedo a la
            legalidad.
          </h2>

          <div className="max-w-3xl mx-auto mb-12 rounded-xl overflow-hidden shadow-2xl border border-white/10" data-id="element-89">
            <img src="https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&q=80&w=1200&h=628" alt="Manos trabajadoras usando un iPad" className="w-full h-auto object-cover aspect-[1.91/1]" data-id="element-90" />
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-91">
            <Button onClick={() => document.getElementById('pricing-cta')?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })} className="w-full md:w-auto md:px-10 py-5 text-xl" data-id="element-92">
              ✅ SÍ, QUIERO EL BLUEPRINT POR $6.36 — ACCESO INMEDIATO
            </Button>

            <div className="flex flex-wrap justify-center gap-4 md:gap-6 mt-4 text-sm text-white/70" data-id="element-93">
              <div className="flex items-center gap-1.5" data-id="element-94">
                <Lock className="w-4 h-4" data-id="element-95" />
                <span data-id="element-96">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-97">
                <ShieldCheck className="w-4 h-4" data-id="element-98" />
                <span data-id="element-99">Garantía de 7 días</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-100">
                <Download className="w-4 h-4" data-id="element-101" />
                <span data-id="element-102">Descarga Inmediata</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}